import React from 'react'
import { useLocation } from 'react-use'
import { Flex, useThemeUI } from 'theme-ui'
import { Global } from '@emotion/react'
import { useStarFilter } from '~/hooks/utils/useStarFilter'

const BazaarStar = ({
  inline = false,
  forwardSx = {},
  product,
  shopAll = '',
}) => {
  const { theme, colorMode } = useThemeUI()
  const location = useLocation()
  const starFilter = useStarFilter(product?.yotpoId, inline, colorMode, shopAll)

  const isHome = location?.pathname === '/' || location?.pathname === '/en-CA/'
  return (
    <>
      <Global
        // Styles for star bars Pop-up with Read xx reviews button as it is at root level
        styles={{
          '& div.bv_modal_component_container[data-bv-modal][role="navigation"]':
            {
              backgroundColor: `${theme.colors.secondary} !important`,
              'div, button': {
                color: `${theme.colors.primary} !important`,
              },
              button: {
                borderColor: `${theme.colors.primary} !important`,
              },
            },
          // BG for each bar
          '& .bv_histogram_row_container[role="menuitem"]:hover': {
            backgroundColor: 'transparent !important',
          },
          // BG for Read XXX Reviews Button
          '& div.bv_modal_component_container[data-bv-modal][role="navigation"] button':
            {
              backgroundColor: 'transparent !important',
            },
          // // Star color same as outside
          // '& .bv_histogram_row_star svg': {
          //   filter: `${starFilter}`,
          // },
        }}
      />

      <Flex
        sx={{
          // Star
          '& .bv_stars_component_container svg, & .bv_stars_svg_no_wrap svg': {
            filter: `${starFilter}`,
          },
          // center align stars on mobile
          '& [data-bv-show="rating_summary"] .bv_main_container': {
            justifyContent: ['center', 'unset', 'unset'],
          },
          // rating summary Text & hover
          '& [data-bv-show="rating_summary"] .bv_main_container .bv_button_buttonMinimalist:hover, [data-bv-show="rating_summary"] .bv_main_container .bv_avgRating_component_container:hover, [data-bv-show="rating_summary"] .bv_main_container .bv_numReviews_text:hover':
            {
              color: `${theme.colors.secondary} !important`,
            },
          '& .bv_avgRating_component_container, [data-bv-show="rating_summary"] .bv_main_container .bv_avgRating_component_container, [data-bv-show="rating_summary"] .bv_main_container .bv_numReviews_text, [data-bv-show="rating_summary"] .bv_main_container .bv_button_buttonMinimalist,':
            {
              color: `${theme.colors.secondary} !important`,
            },
          '[data-bv-rating] .bv_main_container .bv_text, [data-bv-show=inline_rating] .bv_main_container .bv_text':
            {
              color: `${
                isHome ? theme.colors.governorBay : theme.colors.primary
              } !important`,
            },
          // Star gap
          '& [data-bv-show="rating_summary"] .bv_main_container .bv_stars_component_container , [data-bv-show="inline_rating"] .bv_main_container .bv_stars_component_container':
            {
              pr: '0rem !important',
              '& svg': {
                mr: '0.45rem !important',
              },
            },
          ...forwardSx,
        }}
        id="reviewParent"
      >
        {product?.yotpoId &&
          (inline ? (
            <div
              data-bv-show="inline_rating"
              data-bv-product-id={product?.yotpoId}
              data-bv-redirect-url={`http://www.goodles.com/products/${product?.slug}`}
            ></div>
          ) : (
            <div
              data-bv-show="rating_summary"
              data-bv-product-id={product?.yotpoId}
            ></div>
          ))}
      </Flex>
    </>
  )
}

export default BazaarStar
